export const Filtro = Object.freeze({
  COLABORADOR: "COLABORADOR",
  CARGO: "CARGO"
});
